import { AdminGrade, AdminPermission } from '@api/generated/model';
import type { AdminResponseDto } from '@api/generated/model';

/**
 * 개발 전용 인증 우회
 *
 * 백엔드(dev API)에 접근할 수 없는 환경에서 목업 화면을 확인하기 위한 임시 장치.
 * - 반드시 개발 환경(NODE_ENV === 'development') && REACT_APP_AUTH_BYPASS === 'true' 일 때만 동작
 * - 프로덕션 빌드에서는 절대 활성화되지 않음
 * - 확인이 끝나면 .env.local 의 REACT_APP_AUTH_BYPASS 값을 제거하면 즉시 비활성화됨
 *
 * TODO: 백엔드 연동 정상화 후 이 파일과 AuthInitializer 의 우회 분기를 제거한다.
 */
export const AUTH_BYPASS_ENABLED =
	process.env.NODE_ENV === 'development' && process.env.REACT_APP_AUTH_BYPASS === 'true';

// 우회용 목업 토큰
export const DEV_MOCK_TOKEN = 'dev-mock-access-token';

// 우회용 목업 관리자 (MASTER 등급 → 모든 권한 프리패스)
export const DEV_MOCK_ADMIN: AdminResponseDto = {
	adminId: 0,
	email: 'dev@rockandrun.local',
	passwordChangedAt: null,
	passwordChangeRequired: false,
	name: '개발확인용',
	nameHash: '',
	phoneNumber: '',
	phoneNumberHash: '',
	department: '개발',
	position: '',
	grade: AdminGrade.MASTER,
	memo: '',
	failedLoginAttempts: 0,
	accountLocked: false,
	lockUntil: null,
	lastLoginIp: '',
	lastLoginAt: null,
	createdAt: '',
	updatedAt: '',
	tempPasswordIssuedAt: null,
	tempPasswordExpiresAt: null,
	permissions: Object.values(AdminPermission),
	auditLogs: [],
	_count: {
		createdContests: 0,
		createdPrograms: 0,
		createdNews: 0,
		createdFaqs: 0,
		createdProducts: 0,
	},
};
